import React, { createContext, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./Components/Dashboard/Dashboard";
import AdminNavbar from "./common/Navbar";
import PropertiesList from "./Components/Properties/Properties";
import AddProperty from "./Components/Properties/AddProperties";
import AddPropertyIndia from "./Components/Properties/AddPropertyIndia";
import Users from "./Components/Users/Users";
import Register from "./Components/Auth/Register";
import 'react-toastify/dist/ReactToastify.css';
import Login from "./Components/Auth/Login";
import SettingsPage from "./Components/SettingPage/SettingPage";
import { createTheme, ThemeProvider } from "@mui/material";
import Evaluation from "./Components/Evaluation/Evaluation";
import Jobs from "./Components/Jobs/Jobs";
import AddJob from "./Components/Jobs/AddJob";
import Wishlist from "./Components/WishList/Wishlist";
import ArrangeView from "./Components/ArrangeView/ArrangeView";
import Enquiry from "./Components/Enquiry/Enquiry";
import BlogTable from "./Components/Blog/BlogTable";
import AddBlog from "./Components/Blog/AddBlog";
import ContactTable from "./Components/Contacts/ContactTable";
import AreasList from "./Components/Areas/AreasList";
import AddArea from "./Components/Areas/AddArea";
import Card from "./Card";
import { Navigate } from "react-router-dom";
// import Dashboard from './Components/Dashboard/Dashboard';

export const ThemeContext = createContext({ toggleTheme: () => { } });
const App: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);

  // Define Light and Dark Themes
  const lightTheme = createTheme({
    palette: {
      mode: "light",
      background: {
        default: "#ffffff",
        paper: "#f5f5f5",
      },
      text: {
        primary: "#000000",
      },
    },
  });

  const darkTheme = createTheme({
    palette: {
      mode: "dark",
      background: {
        default: "#121212",
        paper: "#1e1e1e",
      },
      text: {
        primary: "#ffffff",
      },
    },
  });

  // Theme Toggle Handler
  const toggleTheme = () => {
    setDarkMode(!darkMode);
  };
  // Simple auth guard using sessionStorage user key
  const RequireAuth: React.FC<{ children: JSX.Element }> = ({ children }) => {
    const user = sessionStorage.getItem('user');
    if (!user) return <Navigate to="/auth/login" replace />;
    return children;
  };
  return (

    <ThemeContext.Provider value={{ toggleTheme }}>
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <Router basename="/">
          <Routes>
            <Route path="/auth/register" element={<Register />} />
            <Route path="/auth/login" element={<Login />} />
            {/* Card routes require auth now */}
            <Route path="/card" element={<RequireAuth><Card /></RequireAuth>} />

            {/* Show Card as the landing page only when logged in */}
            <Route path="/" element={<RequireAuth><Card /></RequireAuth>} />
            {/* <Route path="card" element={<Card />} /> */}
            {/* Dashboard with country query parameter - handled by existing /dashboard route */}
            {/* Protected pages keep AdminNavbar wrapper */}
            <Route path="dashboard" element={<AdminNavbar darkTheme={darkMode}><Dashboard /></AdminNavbar>} />
            <Route path="properties" element={<AdminNavbar darkTheme={darkMode}><PropertiesList /></AdminNavbar>} />
            <Route path="editProperty/:id" element={<AdminNavbar darkTheme={darkMode}><AddProperty /></AdminNavbar>} />
            <Route path="addProperty" element={<AdminNavbar darkTheme={darkMode}><AddProperty /></AdminNavbar>} />
            <Route path="addPropertyIndia" element={<AdminNavbar darkTheme={darkMode}><AddPropertyIndia /></AdminNavbar>} />
            <Route path="editPropertyIndia/:id" element={<AdminNavbar darkTheme={darkMode}><AddPropertyIndia /></AdminNavbar>} />
            <Route path="addJob" element={<AdminNavbar darkTheme={darkMode}><AddJob /></AdminNavbar>} />
            <Route path="blogs" element={<AdminNavbar darkTheme={darkMode}><BlogTable /></AdminNavbar>} />
            <Route path="addBlog" element={<AdminNavbar darkTheme={darkMode}><AddBlog /></AdminNavbar>} />
            <Route path="editBlog/:id" element={<AdminNavbar darkTheme={darkMode}><AddBlog /></AdminNavbar>} />
            <Route path="settings" element={<AdminNavbar darkTheme={darkMode}><SettingsPage /></AdminNavbar>} />
            <Route path="users" element={<AdminNavbar darkTheme={darkMode}><Users /></AdminNavbar>} />
            <Route path="jobs" element={<AdminNavbar darkTheme={darkMode}><Jobs /></AdminNavbar>} />
            <Route path="wishlist" element={<AdminNavbar darkTheme={darkMode}><Wishlist /></AdminNavbar>} />
            <Route path="valuations" element={<AdminNavbar darkTheme={darkMode}><Evaluation /></AdminNavbar>} />
            <Route path="contacts" element={<AdminNavbar darkTheme={darkMode}><ContactTable /></AdminNavbar>} />
            <Route path="areas" element={<AdminNavbar darkTheme={darkMode}><AreasList /></AdminNavbar>} />
            <Route path="addArea" element={<AdminNavbar darkTheme={darkMode}><AddArea /></AdminNavbar>} />
            <Route path="editArea/:id" element={<AdminNavbar darkTheme={darkMode}><AddArea /></AdminNavbar>} />
            <Route path="enquiry" element={<AdminNavbar darkTheme={darkMode}><Enquiry /></AdminNavbar>} />
            <Route path="arrangeView" element={<AdminNavbar darkTheme={darkMode}><ArrangeView /></AdminNavbar>} />

            {/* Fallback: send unknown routes to Card when logged in otherwise to login */}
            <Route path="*" element={<RequireAuth><Card /></RequireAuth>} />
          </Routes>
        </Router>
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export default App;